const SYSTEM_PARAMS = new Set(["gcpProjectId"]);

/**
 * Extract `{placeholder}` names from a SQL template, excluding system params
 * like `gcpProjectId` which are auto-provided by the platform at compile time.
 */
export function detectPlaceholders(sql: string): string[] {
  const seen = new Set<string>();
  const results: string[] = [];
  const pattern = /\{([^}]+)\}/g;
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(sql)) !== null) {
    const name = match[1] ?? "";
    if (!SYSTEM_PARAMS.has(name) && !seen.has(name)) {
      seen.add(name);
      results.push(name);
    }
  }
  return results;
}
